import { motion } from 'framer-motion';
import { Outlet, useParams } from 'react-router-dom';

import { PageDetailContent } from '@client/toolkit';

import { InvestmentsCard } from '../../../components/investments-card/investments-card.component';

export function BuildingInvestmentsRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();

  return (
    <>
      <PageDetailContent align="left">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            opacity: { ease: 'linear', duration: 0.2 },
            y: { ease: 'easeInOut', duration: 0.4 },
          }}
        >
          <InvestmentsCard buildingId={buildingId} />
        </motion.div>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
